import employeesSagas from 'modules/users/employees/store/sagas';
import managersSagas from 'modules/users/managers/store/sagas';

export default [
    ...employeesSagas,
    ...managersSagas,
];
